import React from "react";
import { Modal, Button } from "antd";
import crossIcon from "../../assets/images/Frame 48.png";
import { IMAGE_BASE_URL } from "../../config/api";
import { Download } from "lucide-react";

const ImagePreview = ({
  imagePreviewUrl,
  videoUrl,
  description,
  closeImagePreview,
  isPreviewOpen,
  userProfile,
  userName,
  storyTime,
}) => {
  const hasMedia = videoUrl || imagePreviewUrl;

  const handleDownload = async () => {
    try {
      const response = await fetch(IMAGE_BASE_URL + imagePreviewUrl, {
        mode: "cors",
      });
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${imagePreviewUrl}.jpg`; 
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Failed to download image:", error);
    }
  };

  return (
    <Modal
      visible={isPreviewOpen}
      onCancel={closeImagePreview}
      footer={null}
      centered
      width="100%"
      style={{ maxWidth: '100vw', top: 0, padding: 0 }}
      bodyStyle={{ padding: 0, height: '100vh' }}
      closeIcon={
        <img
          src={crossIcon}
          alt="Close Icon"
          className="w-6 h-6 absolute top-4 right-4 z-50"
        />
      }
      className="image-preview-modal"
    >
      <div className="relative h-full w-full flex items-center justify-center bg-black/90">
        {/* Download Button */}
        <button 
          icon={<Download size={16} />}
          onClick={handleDownload}
          className="absolute top-4 right-16 z-50 w-[140px] py-1 rounded-[4px] bg-[#F97316] font-medium text-base text-white"
        >
          Download Image
        </button>

        {/* Image */}
        <img
          className="max-h-[90vh] max-w-[90vw] object-contain"
          src={IMAGE_BASE_URL + imagePreviewUrl}
          alt="imagePreview"
        />

        {/* Description */}
        {description && (
          <div className="absolute bottom-4 left-0 right-0 text-center">
            <p className="text-white text-xl bg-black/50 p-4 rounded-lg mx-4">{description}</p>
          </div>
        )}

        {/* User Profile Info */}
        {(userProfile || userName || storyTime) && (
          <div className="absolute top-4 left-4 flex items-center text-white z-10 bg-black/50 p-2 rounded-lg">
            {userProfile && (
              <img
                src={userProfile}
                alt="User Profile"
                className="w-9 h-9 rounded-full mr-2"
              />
            )}
            {userName && <span className="text-base font-semibold mr-2">{userName}</span>}
            {storyTime && <span className="text-sm">{storyTime}</span>}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default ImagePreview;
